import { useEffect, useState } from "react"
import Modal from "../../../molecules/Modal"
import Input from "../../../atoms/Input"
import Select from "../../../atoms/Select"
import { toast } from "@stardust-ds/react"
import intl from "react-intl-universal"

import EditIcon from "../../../../assets/icons/EditIcon"
import Button from "../../../atoms/Button"
import { useForm, FormProvider } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import styles from "./index.module.scss"
import ClockRotateIcon from "../../../../assets/icons/ClockRotateIcon"
import RcmpLoading from "../../../atoms/Loading"
import SwitchComponent from "../../../atoms/Switch"
import WarningIcon from "../../../../assets/icons/Warning"
import RcmpTextArea from "../../../atoms/TextArea"
import { ModalInformation } from "../components/ModalInformation"
import { schema } from "../yup/schemaValidation"
import {
  editAnalyte,
  createResultOption,
  listResultOptions,
  listSectors,
  createSector,
  listAnalyteId,
  listHistoryAnalyte,
  getVariableBiologic,
} from "../../../../services/ciq"
import MultiSelect from "../components/MultiSelect"
import { fnFormatDateFromUTC } from "../../../../utils/date"
import { fnCanAtLeast } from "../../../../utils/permissions"
import { HistoryComponent } from "../components/HistoryComponent"
import { useContext } from "react"
import { Table } from "../../../molecules/Table"
import AuthContext from "../../../../contexts/Auth"

export const ModalEditAnalite = ({ onClose, setUpdateList, analyteId }) => {
  const [modalLoading, setModalLoading] = useState(false)

  const [optsResult, setOptsResults] = useState([])
  const [optsSector, setOptsSector] = useState([])

  const [isTabEdit, setIsTabEdit] = useState(true)
  const [isCancelModal, setIsCancelModal] = useState(false)
  const [isSubmitlModal, setIsSubmitModal] = useState(false)

  const [isLoadBtn, setIsLoadBtn] = useState(false)

  const [isChecked, setChecked] = useState(true)

  const [isLoading, setIsLoading] = useState(false)

  const [selectType, setSelectType] = useState({
    label: "",
    value: "",
  })

  const [objAnalyte, setObjAnalyte] = useState({})
  const [cname, setCname] = useState(objAnalyte?.anlt_cname)

  const [isLoadHistory, setIsLoadHistory] = useState(false)

  const [defaultSector, setDefaultSector] = useState([])
  const [defaultResult, setDefaultResult] = useState([])
  const [infoInfinitScroll, setInfoInfinitScroll] = useState({})
  const [isSwitchChange, setIsSwitchChange] = useState(false)
  const [isOpenModalStatus, setisOpenModalStatus] = useState(false)
  const [defaultOptSelect, setDefaultOptSelect] = useState()
  const [biologicalVariable, setBiologicalVariable] = useState([])
  const [biologicalVariableDefault, setBiologicalVariableDefault] = useState([])
  const [bDesviculateBiologial, setBDesviculateBiologial] = useState(false)

  const [isChange, setIsChange] = useState(false)

  const [nDecimal, setNDecimal] = useState(0)
  const [per_page, setPerPage] = useState(1)

  const [search_type, setSearchType] = useState("")
  const [text_type, setTextType] = useState("")

  const [dataHistory, setDataHistory] = useState([])

  const types = [
    {
      label: intl.get("ciq.types_analytes.quantitative"),
      value: intl.get("ciq.types_analytes.quantitative"),
    },
    {
      label: intl.get("ciq.types_analytes.qualitative"),
      value: intl.get("ciq.types_analytes.qualitative"),
    },
    {
      label: intl.get("ciq.types_analytes.semmi_quantitative"),
      value: intl.get("ciq.types_analytes.semmi_quantitative"),
    },
  ]

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  })

  const {
    handleSubmit,
    register,
    setValue,
    trigger,
    formState: { errors },
  } = methods

  const handleActive = () => {
    setIsTabEdit((oldState) => !oldState)
  }

  const cAnalyteType = selectType?.value?.toLocaleLowerCase()

  const typeMapping = {
    Quantitative: "Quantitativo",
    Qualitative: "Qualitativo",
    "Semi-Quantitative": "Semi-Quantitativo",
    Quantitativo: "Quantitativo",
    Qualitativo: "Qualitativo",
    "Semi-Quantitativo": "Semi-Quantitativo",
  }
  const transformType = (type) => {
    return typeMapping[type] || type
  }

  const submitEditAnalitos = async (data) => {
    try {
      setIsLoading(true)
      const anlt_decimal_places = !data.anlt_decimal_places
        ? nDecimal
        : data.anlt_decimal_places

      const anlt_bstatus = !data.anlt_bstatus ? isChecked : data.anlt_bstatus

      const newData = {
        ...data,
        anlt_cname: data.anlt_cname?.trim(),
        anlt_unit_of_measure: data.anlt_unit_of_measure?.trim(),
        anlt_decimal_places,
        anlt_bstatus,
        anlt_observation: data.anlt_observation ? data.anlt_observation?.trim() : null,
        anlt_type: transformType(data.anlt_type),
      }

      // QUANTITATIVO
      if (cAnalyteType === "quantitativo") {
        if (objAnalyte?.anlt_biovar?.biovar_nid) {
          const biologicalVariableIsLinkedAnalyteOrEquipment = biologicalVariable
            .filter((item) => item.id === objAnalyte?.anlt_biovar?.biovar_nid)[0]
            .analytes.find(
              (it) => it.anlt_cname === objAnalyte.anlt_cname,
            ).equipment_biovar_activated

          const biologicalVariableSelected = biologicalVariable.filter(
            (item) => item.id === objAnalyte?.anlt_biovar?.biovar_nid,
          )

          if (biologicalVariableIsLinkedAnalyteOrEquipment) {
            const dtVar = biologicalVariableSelected.map((item) => ({
              id: item.id,
              label: item.label,
              value: item.value,
            }))

            setBiologicalVariableDefault(dtVar[0])
            setBDesviculateBiologial(true)

            return
          }
        }
        delete newData.anlt_result_options

        await editAnalyte(analyteId, newData)
        fnCloseAllModals()
        setUpdateList((oldState) => !oldState)
        return
      }

      // QUALITATIVO
      if (cAnalyteType === "qualitativo") {
        if (newData.anlt_result_options.length < 2) {
          return
        } else {
          delete newData.anlt_decimal_places
          delete newData.anlt_unit_of_measure
          // SUBMETER ANALITOS QUALITATIVO

          await editAnalyte(analyteId, newData)
          fnCloseAllModals()
          setUpdateList((oldState) => !oldState)

          return
        }
      }

      // SEMI-QUANTITATIVO
      if (cAnalyteType === "semi-quantitativo") {
        if (newData.anlt_result_options.length <= 1) {
          return
        } else {
          delete newData.anlt_decimal_places
          delete newData.anlt_unit_of_measure

          await editAnalyte(analyteId, newData)
          fnCloseAllModals()
          setUpdateList((oldState) => !oldState)
          return
        }
      }
    } catch (err) {
      fnOpenToastFail(err.response?.data.message)
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }

  function fnOpenToastFail(message) {
    return toast({
      type: "error",
      title: "Erro",
      description: message,
    })
  }

  const fnCloseAllModals = () => {
    setIsCancelModal(false)
    onClose()
    setIsSubmitModal(false)
  }

  const fnIsError = (message) => {
    return message?.message ? styles.error : ""
  }

  const fnPermitionOnlyFiveCaracter = (e) => {
    setIsChange(true)
  }

  const postResult = async (result) => {
    try {
      setIsLoadBtn(true)
      await createResultOption({ resultopt_cdescription: result })

      await getListResultOptions()
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoadBtn(false)
    }
  }
  const postSector = async (sector_name) => {
    try {
      setIsLoadBtn(true)
      await createSector({ sector_cname: sector_name })

      await getListSectors()
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoadBtn(false)
    }
  }

  const getListResultOptions = async () => {
    try {
      const { data: dt } = await listResultOptions()

      const newData = dt.data.map((item) => ({
        label: item.resultopt_cdescription,
        value: item.resultopt_cdescription,
        resultopt_dcreated: item.resultopt_dcreated,
        resultopt_dupdated: item.resultopt_dupdated,
        id: item.resultopt_nid,
      }))

      setOptsResults(newData)
    } catch (err) {
      console.log(err)
    }
  }
  const getListSectors = async () => {
    try {
      const { data: dt } = await listSectors()

      const newData = dt.data.map((item) => ({
        label: item.sector_cname,
        value: item.sector_cname,
        sector_dcreated: item.sector_dcreated,
        sector_dupdated: item.sector_dupdated,
        id: item.sector_nid,
      }))

      setOptsSector(newData)
    } catch (err) {
      console.log(err)
    }
  }

  const getBiologicalVariationTable = async () => {
    try {
      setModalLoading(true)

      const response = await getVariableBiologic()
      setBiologicalVariable(
        response.data.data.map((item) => ({
          analytes: item.analytes,
          label: item.biological_variation_summary,
          value: item.biological_variation_summary,
          id: item.biovar_nid,
        })),
      )
      return response
    } catch (err) {
      console.log(err)
    }
  }

  const getAnalyte = async (id) => {
    try {
      setModalLoading(true)
      const { data: dt } = await listAnalyteId(id)

      setObjAnalyte(dt.data)

      const defaultOptions = {
        value:
          dt.data.anlt_type === "Quantitativo"
            ? intl.get("ciq.types_analytes.quantitative")
            : dt.data.anlt_type === "Qualitativo"
            ? intl.get("ciq.types_analytes.qualitative")
            : intl.get("ciq.types_analytes.semmi_quantitative"),
        label:
          dt.data.anlt_type === "Quantitativo"
            ? intl.get("ciq.types_analytes.quantitative")
            : dt.data.anlt_type === "Qualitativo"
            ? intl.get("ciq.types_analytes.qualitative")
            : intl.get("ciq.types_analytes.semmi_quantitative"),
      }

      setDefaultOptSelect(defaultOptions)

      setValue("anlt_cname", dt.data.anlt_cname)

      setValue("anlt_unit_of_measure", dt.data.anlt_unit_of_measure)
      setValue("anlt_decimal_places", dt.data.anlt_decimal_places)

      setNDecimal(dt.data.anlt_decimal_places || 0)

      setValue("anlt_observation", dt.data.anlt_observation)

      const defaultOptSector = {
        label: dt.data.anlt_sector.sector_cname,
        value: dt.data.anlt_sector.sector_cname,
        sector_dcreated: dt.data.anlt_sector.sector_dcreated,
        sector_dupdated: dt.data.anlt_sector.sector_dupdated,
        id: dt.data.anlt_sector.sector_nid,
      }

      setCname(dt.data.anlt_cname)

      setChecked(dt.data.anlt_bstatus)

      setDefaultSector(defaultOptSector)

      setValue("anlt_sector_nid", [defaultOptSector.id])

      if (
        dt.data.anlt_type === "Qualitativo" ||
        dt.data.anlt_type === "Semi-Quantitativo"
      ) {
        const defaultOptResult = dt.data.anlt_result_options.map((item) => {
          return {
            label: item.resultopt_cdescription,
            value: item.resultopt_cdescription,
            resultopt_dcreated: item.resultopt_dcreated,
            resultopt_dupdated: item.resultopt_dupdated,
            id: item.resultopt_nid,
          }
        })

        setDefaultResult(defaultOptResult)
        setValue("anlt_result_options", defaultOptResult?.map((item) => item?.id) || [])
      }

      setSelectType({
        label: transformType(dt.data.anlt_type),
        value: transformType(dt.data.anlt_type),
      })
      setValue("anlt_type", transformType(dt.data.anlt_type))

      if (dt?.data?.anlt_biovar) {
        const obj = {
          label: dt.data?.anlt_biovar?.biological_variation_summary,
          value: dt.data?.anlt_biovar?.biological_variation_summary,
          id: dt.data?.anlt_biovar?.biovar_nid,
        }

        setBiologicalVariableDefault(obj)
      }

      setIsChange(false)
    } catch (err) {
      console.error(err)
    } finally {
      setModalLoading(false)
    }
  }

  const { oUser } = useContext(AuthContext)

  const cUserTimeZone = oUser?.data?.user_ctimezone

  const getHistory = async (id, perPage, searchType, textType) => {
    try {
      setDataHistory([])
      setIsLoadHistory(true)
      const { data: dt } = await listHistoryAnalyte(id, perPage, searchType, textType)

      const newDataHistory = dt.data.data.map((item) => {
        const [data, hour] = fnFormatDateFromUTC(
          item.history_dupdated,
          "DD/MM/YYYY - HH:mm",
          cUserTimeZone,
        ).split(" - ")

        return {
          ...item,
          history_caction: item.history_caction,
          history_data: data,
          history_hour: hour,
          history_user_cname: item.history_user?.cname,
        }
      })

      setDataHistory(newDataHistory)

      setInfoInfinitScroll({
        last_page: dt.data.last_page,
        next_page_url: dt.data.next_page_url,
        data_length: dt.data.data.length,
      })
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoadHistory(false)
    }
  }

  useEffect(() => {
    if (!objAnalyte.anlt_type?.includes(selectType.value.slice(0, -1))) {
      setDefaultResult([])
      setValue("anlt_result_options", [])
    }
  }, [!objAnalyte.anlt_type?.includes(selectType.value.slice(0, -1))])

  useEffect(() => {
    getListResultOptions()
    getListSectors()
  }, [selectType.value])

  useEffect(() => {
    if (
      !fnCanAtLeast("create-edit-analyte", "internal-quality-control") &&
      (fnCanAtLeast("create-edit-equipment", "internal-quality-control") ||
        fnCanAtLeast("create-edit-control", "internal-quality-control") ||
        fnCanAtLeast("create-edit-launch", "internal-quality-control") ||
        fnCanAtLeast("update-run", "internal-quality-control"))
    ) {
      window.location.href = "/"
      return
    }

    getAnalyte(analyteId)
  }, [])

  useEffect(() => {
    getHistory(analyteId, per_page, search_type, text_type)
  }, [per_page, search_type, text_type])

  useEffect(() => {
    const bAdmin = fnCanAtLeast("admin", "internal-quality-control")

    if (bAdmin || fnCanAtLeast("create-edit-analyte", "internal-quality-control")) {
      return
    } else if (
      fnCanAtLeast("create-edit-equipment", "internal-quality-control") ||
      fnCanAtLeast("create-edit-control", "internal-quality-control") ||
      fnCanAtLeast("update-run", "internal-quality-control")
    ) {
      window.location.href = "/"
      return
    }
  }, [])

  useEffect(() => {
    if (!isTabEdit) {
      setSearchType("")
      setTextType("")
    }
  }, [isTabEdit === false])

  useEffect(() => {
    getBiologicalVariationTable()
  }, [])

  return (
    <FormProvider {...methods}>
      <Modal isOpen={true} size={isSubmitlModal || isOpenModalStatus ? "md" : "xlg"}>
        <Modal.Header
          style={{
            padding: "0.5rem",
            justifyContent:
              (isOpenModalStatus && isChecked) || (isOpenModalStatus && !isChecked)
                ? "center"
                : "left",
          }}
          onClose={() => {
            if (isSubmitlModal) {
              setIsSubmitModal(false)
            } else if (isChange) {
              setIsCancelModal(true)
            } else {
              fnCloseAllModals()
            }
          }}
        >
          <h1 className={styles.titleModal}>
            {isOpenModalStatus && isChecked
              ? intl.get("ciq.active_exam_analytes")
              : isOpenModalStatus && !isChecked
              ? intl.get("ciq.inactive_exam_analytes")
              : intl.get("ciq.edit_exam_analyte")}
          </h1>
        </Modal.Header>

        {modalLoading ? (
          <div className={styles.flexCenter} style={{}}>
            <RcmpLoading bShow={true} />
          </div>
        ) : (
          <form
            className={styles.form}
            onSubmit={handleSubmit(submitEditAnalitos)}
            autoComplete="off"
          >
            {isOpenModalStatus ? (
              <>
                <div className={styles.flexCenter}>
                  <WarningIcon />
                  {isChecked ? (
                    <p>
                      {intl.get("ciq.are_you_sure_active_analyte", { analyte: cname })}
                    </p>
                  ) : (
                    <p>
                      {intl.get("ciq.are_you_sure_inactive_analyte", { analyte: cname })}
                    </p>
                  )}
                </div>
                <div className={styles.containerButton}>
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => {
                      setisOpenModalStatus(false)
                      setIsSubmitModal(false)
                    }}
                  >
                    {intl.get("activityModelModal.close_when_change_field_cancel")}
                  </Button>
                  <Button
                    style={{ background: isChecked ? "#1ECB4F" : "red" }}
                    type="button"
                    onClick={() => {
                      setTimeout(() => {
                        setisOpenModalStatus(false)
                        setIsSubmitModal(true)
                      }, 100)
                    }}
                  >
                    {intl.get("ciq.yes_continue")}
                  </Button>
                </div>
              </>
            ) : isSubmitlModal ? (
              <>
                <div className={styles.flexCenter}>
                  <WarningIcon />
                  <p>{intl.get("ciq.question_save")}</p>
                </div>
                <div className={styles.containerButton}>
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => setIsSubmitModal(false)}
                  >
                    {intl.get("activityModelModal.close_when_change_field_cancel")}
                  </Button>
                  <Button
                    style={{ background: "#1ECB4F" }}
                    type="submit"
                    isLoading={isLoading}
                  >
                    {intl.get("ciq.yes_continue")}
                  </Button>
                </div>
              </>
            ) : (
              <Modal.Content
                size="lg"
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                }}
              >
                <div className={styles.flexColumn}>
                  <div
                    className={styles.containerEditAndHistory}
                    onClick={() => handleActive()}
                  >
                    <span className={isTabEdit ? styles.active : styles.desactive}>
                      <EditIcon />
                      {intl.get("edit")}
                    </span>
                    <span className={!isTabEdit ? styles.active : styles.desactive}>
                      <ClockRotateIcon flll="#6cb6e3" />
                      {intl.get("history")}
                    </span>
                  </div>
                </div>

                {isTabEdit ? (
                  <>
                    {/* START OF FORM FIELDS ========================================= */}

                    <div className={styles.flexLine}>
                      <div className={styles.inputId}>
                        <Input label="ID" width="100%" disabled value={analyteId} />
                      </div>
                      <div
                        className={`${styles.itemFlex} ${fnIsError(errors?.anlt_cname)}`}
                      >
                        <Input
                          label={intl.get("modal_form_list.name") + "*"}
                          width="100%"
                          {...register("anlt_cname")}
                          placeholder={intl.get("ciq.type_here")}
                          onChange={(e) => {
                            setCname(e.target.value)
                            setIsChange(true)
                          }}
                          value={cname}
                        />

                        {fnIsError(errors?.anlt_cname) && (
                          <span>{errors?.anlt_cname?.message}</span>
                        )}
                      </div>

                      <div
                        style={{ width: "3rem" }}
                        className={`${styles.itemFlex} 
                  ${fnIsError(errors?.anlt_type)}
                `}
                      >
                        <Select
                          label={intl.get("ciq.header_table_list_analyte.type") + "*"}
                          options={types}
                          placeholder={intl.get("ciq.select_a_type")}
                          searchable={false}
                          width="100%"
                          defaultValue={defaultOptSelect}
                          className={styles.select}
                          bIsDisabled={true}
                        />

                        {fnIsError(errors?.anlt_type) && (
                          <span>{errors?.anlt_type?.message}</span>
                        )}
                      </div>

                      <div className={styles.containerSwitch}>
                        <label>{intl.get("modal_form_list.status")}</label>
                        <SwitchComponent
                          width="10rem"
                          label={intl.get("modal_form_list.status")}
                          onClick={(e) => {
                            setChecked((oldState) => !oldState)
                            setValue("anlt_bstatus", !isChecked)
                            setIsChange(true)
                            if (isChecked) {
                              toast({
                                type: "warning",
                                title: intl.get("ciq.changed_status"),
                                description: intl.get("ciq.changed_status_infon"),
                              })
                            }
                          }}
                          cDisabledText={intl.get("ciq.inactive_up")}
                          cAbleText={intl.get("ciq.active_up")}
                          value={isChecked}
                        />
                      </div>
                    </div>

                    {/* QUANTITATIVO ========================= */}

                    {cAnalyteType === "quantitativo" && (
                      <div className={styles.flexColumn}>
                        <div className={styles.flexLine}>
                          <div
                            className={`${styles.itemFlex} 
                      ${fnIsError(errors?.anlt_unit_of_measure)}
                   `}
                          >
                            <Input
                              label={intl.get("ciq.create_analytes.unit") + "*"}
                              width="100%"
                              {...register("anlt_unit_of_measure")}
                              onChange={fnPermitionOnlyFiveCaracter}
                              placeholder={intl.get("ciq.type_here")}
                            />
                            {fnIsError(errors?.anlt_unit_of_measure) && (
                              <span>{errors?.anlt_unit_of_measure?.message}</span>
                            )}
                          </div>
                          {/* componente setor */}
                          <div style={{ zIndex: 9999, width: "35%" }}>
                            <MultiSelect
                              width="100%"
                              label={
                                intl.get("ciq.header_table_list_analyte.sector") + "*"
                              }
                              placeholder={intl.get("ciq.select_one_sector")}
                              limitOptsSelected={1}
                              onSelect={(e) => {
                                setValue("anlt_sector_nid", e.map((item) => item.id)[0])
                                setIsChange(true)
                              }}
                              opts={optsSector}
                              isError={fnIsError(errors?.anlt_sector_nid)}
                              messageError={errors?.anlt_sector_nid?.message}
                              onCreateOption={postSector}
                              isloading={isLoadBtn}
                              type="sector"
                              bIsEdit={true}
                              defaultOptValue={defaultSector}
                            />
                          </div>
                          <div
                            className={`${styles.itemFlex} ${fnIsError(
                              errors?.anlt_cname,
                            )}`}
                          >
                            <Input
                              isFullWidth
                              type="number"
                              label={intl.get(
                                "ciq.modal_create_analytos.fields.ndecimals",
                              )}
                              min={0}
                              max={5}
                              defaultValue={nDecimal}
                              value={nDecimal}
                              onChange={(e) => {
                                setNDecimal(e)
                                setIsChange(true)
                                setValue("anlt_decimal_places", e)
                              }}
                            />
                            {fnIsError(errors?.anlt_decimal_places) && (
                              <span>{errors?.anlt_decimal_places?.message}</span>
                            )}
                          </div>
                        </div>

                        {/* TABELA DE VARIAÇÃO BIOLÓGICA */}
                        <div className={styles.equipmentContaner}>
                          <MultiSelect
                            label={intl.get(
                              "ciq.header_table_list_analyte.variation_biologic",
                            )}
                            placeholder={intl.get("selection")}
                            limitOptsSelected={1}
                            onSelect={(e) => {
                              // if (biologicalVariableDefault.isVinculate) {
                              //   toast({
                              //     type: "warning",
                              //     title: intl.get(
                              //       "ciq.header_table_list_analyte.variation_biologic",
                              //     ),
                              //     description: intl.get(
                              //       "ciq.info_unlinked_biological_variable",
                              //     ),
                              //   })
                              // }

                              setValue(
                                "anlt_biovar_nid",
                                e.map((item) => item.id)[0] || null,
                              )
                              setIsChange(true)

                              setBiologicalVariableDefault(e)
                            }}
                            // opts={[]}
                            opts={biologicalVariable}
                            defaultOptValue={biologicalVariableDefault}
                            type="sector"
                            bIsEdit={true}
                            bInactiveBtn
                          />
                        </div>

                        <div className={styles.equipmentContainer}>
                          <label>{intl.get("ciq.liked_equipment")}</label>
                          <Table
                            cTextNoData={intl.get("ciq.equipment_not_linked_text")}
                            cursorNormal
                            bEdit={false}
                            thead={[
                              intl.get("ciq.equipment"),
                              intl.get("ciq.tipe_imprecision"),
                              intl.get("ciq.value_imprecision"),
                            ]}
                            tbodyArray={objAnalyte.anlt_equipments
                              ?.map((item) => ({
                                equipment_cname: item.equipment_cname,
                                ...item.equipment_analyte,
                              }))
                              ?.map((item) => ({
                                equipment_cname: item.equipment_cname,
                                eqpanlt_eimprecision_type: item.eqpanlt_bmax_imprecision
                                  ? item.eqpanlt_eimprecision_type === "MANUAL"
                                    ? intl.get("ciq.manual_imprecision")
                                    : intl.get("ciq.biological_variation")
                                  : "-",
                                eqpanlt_nimprecision_value:
                                  item.eqpanlt_bmax_imprecision &&
                                  item.eqpanlt_eimprecision_type === "MANUAL"
                                    ? item.eqpanlt_nimprecision_value
                                    : "-",
                              }))}
                          />
                        </div>

                        <RcmpTextArea
                          className={`${styles.itemFlex}`}
                          label={intl.get("ciq.observation")}
                          {...register("anlt_observation")}
                          placeholder={intl.get("ciq.type_here")}
                          onChange={() => {
                            setIsChange(true)
                          }}
                        />
                      </div>
                    )}

                    {/* QUALITATIVO ====================================== */}
                    {cAnalyteType === "qualitativo" && (
                      <div className={styles.flexColumn} style={{ gap: "1rem 0.5rem" }}>
                        <div className={styles.flexLine} style={{ zIndex: 99999 }}>
                          <MultiSelect
                            width="100%"
                            label={intl.get("ciq.header_table_list_analyte.sector") + "*"}
                            placeholder={intl.get("ciq.select_one_sector")}
                            limitOptsSelected={1}
                            onSelect={(e) => {
                              setIsChange(true)

                              setValue("anlt_sector_nid", e.map((item) => item.id)[0])
                            }}
                            opts={optsSector}
                            isError={fnIsError(errors?.anlt_sector_nid)}
                            messageError={errors?.anlt_sector_nid?.message}
                            onCreateOption={postSector}
                            isloading={isLoadBtn}
                            type="sector"
                            bIsEdit={true}
                            defaultOptValue={defaultSector}
                          />
                        </div>

                        <MultiSelect
                          label={intl.get("ciq.opt_results") + "*"}
                          placeholder={intl.get("ciq.select_two_opts")}
                          onSelect={(e) => {
                            setIsChange(true)
                            setValue(
                              "anlt_result_options",
                              e.map((item) => item.id),
                            )
                          }}
                          opts={optsResult}
                          isError={fnIsError(errors?.anlt_result_options)}
                          messageError={errors?.anlt_result_options?.message}
                          onCreateOption={postResult}
                          isloading={isLoadBtn}
                          type="semi-quantitativo"
                          bIsEdit={true}
                          defaultOptValue={defaultResult}
                        />

                        <div className={styles.equipmentContainer}>
                          <label>{intl.get("ciq.liked_equipment")}</label>
                          <Table
                            cTextNoData={intl.get("ciq.equipment_not_linked_text")}
                            cursorNormal
                            bEdit={false}
                            thead={[
                              intl.get("ciq.equipment"),
                              intl.get("ciq.tipe_imprecision"),
                              intl.get("ciq.value_imprecision"),
                            ]}
                            tbodyArray={objAnalyte.anlt_equipments
                              ?.map((item) => ({
                                equipment_cname: item.equipment_cname,
                                ...item.equipment_analyte,
                              }))
                              ?.map((item) => ({
                                equipment_cname: item.equipment_cname,
                                eqpanlt_eimprecision_type: item.eqpanlt_bmax_imprecision
                                  ? item.eqpanlt_eimprecision_type === "MANUAL"
                                    ? intl.get("ciq.manual_imprecision")
                                    : intl.get("ciq.biological_variation")
                                  : "-",
                                eqpanlt_nimprecision_value: item.eqpanlt_bmax_imprecision
                                  ? item.eqpanlt_nimprecision_value
                                  : "-",
                              }))}
                          />
                        </div>

                        <RcmpTextArea
                          placeholder={intl.get("ciq.type_here")}
                          className={`${styles.itemFlex}`}
                          label={intl.get("ciq.observation")}
                          {...register("anlt_observation")}
                          onChange={() => {
                            setIsChange(true)
                          }}
                        />
                      </div>
                    )}

                    {/* SEMI - QUANTITATIVO ====================================== */}
                    {cAnalyteType === "semi-quantitativo" && (
                      <div className={styles.flexColumn} style={{ gap: "1rem 0.5rem" }}>
                        <div className={styles.flexLine} style={{ zIndex: 99999 }}>
                          <MultiSelect
                            width="100%"
                            label={intl.get("ciq.header_table_list_analyte.sector") + "*"}
                            placeholder={intl.get("ciq.select_one_sector")}
                            limitOptsSelected={1}
                            onSelect={(e) => {
                              setIsChange(true)
                              setValue("anlt_sector_nid", e.map((item) => item.id)[0])
                            }}
                            opts={optsSector}
                            isError={fnIsError(errors?.anlt_sector_nid)}
                            messageError={errors?.anlt_sector_nid?.message}
                            onCreateOption={postSector}
                            isloading={isLoadBtn}
                            type="sector"
                            bIsEdit={true}
                            defaultOptValue={defaultSector}
                          />
                        </div>

                        <MultiSelect
                          label={intl.get("ciq.opt_results") + "*"}
                          placeholder={intl.get("ciq.select_two_opts")}
                          onSelect={(e) => {
                            setIsChange(true)
                            setValue(
                              "anlt_result_options",
                              e.map((item) => item.id),
                            )
                          }}
                          opts={optsResult}
                          isError={fnIsError(errors?.anlt_result_options)}
                          messageError={errors?.anlt_result_options?.message}
                          onCreateOption={postResult}
                          isloading={isLoadBtn}
                          type="semi-quantitativo"
                          bIsEdit={true}
                          defaultOptValue={
                            objAnalyte.anlt_type.slice(selectType.value)
                              ? defaultResult
                              : []
                          }
                        />

                        <div className={styles.equipmentContainer}>
                          <label>{intl.get("ciq.liked_equipment")}</label>
                          <Table
                            cTextNoData={intl.get("ciq.equipment_not_linked_text")}
                            cursorNormal
                            bEdit={false}
                            thead={[
                              intl.get("ciq.equipment"),
                              intl.get("ciq.tipe_imprecision"),
                              intl.get("ciq.value_imprecision"),
                            ]}
                            tbodyArray={objAnalyte.anlt_equipments
                              ?.map((item) => ({
                                equipment_cname: item.equipment_cname,
                                ...item.equipment_analyte,
                              }))
                              ?.map((item) => ({
                                equipment_cname: item.equipment_cname,
                                eqpanlt_eimprecision_type: item.eqpanlt_bmax_imprecision
                                  ? item.eqpanlt_eimprecision_type === "MANUAL"
                                    ? intl.get("ciq.manual_imprecision")
                                    : intl.get("ciq.biological_variation")
                                  : "-",
                                eqpanlt_nimprecision_value: item.eqpanlt_bmax_imprecision
                                  ? item.eqpanlt_nimprecision_value
                                  : "-",
                              }))}
                          />
                        </div>

                        <RcmpTextArea
                          placeholder={intl.get("ciq.type_here")}
                          className={`${styles.itemFlex}`}
                          label={intl.get("ciq.observation")}
                          {...register("anlt_observation")}
                          onChange={() => {
                            setIsChange(true)
                          }}
                        />
                      </div>
                    )}

                    <div className={styles.containerButton}>
                      <Button
                        type="button"
                        variant="outline"
                        onClick={() => {
                          if (isChange) {
                            setIsCancelModal(true)
                          } else {
                            fnCloseAllModals()
                          }
                        }}
                      >
                        {intl.get("cancel")}
                      </Button>
                      <Button
                        type="button"
                        onClick={() => {
                          trigger()
                          if (isSwitchChange) {
                            setisOpenModalStatus(true)
                          } else {
                            setisOpenModalStatus(false)
                            trigger().then((isValid) => {
                              if (isValid) setIsSubmitModal(true)
                            })
                          }
                        }}
                      >
                        {intl.get("ciq.btn_save")}
                      </Button>
                    </div>
                  </>
                ) : (
                  // HISTORICO =========================================
                  <HistoryComponent
                    searchHistory="analyte"
                    history={dataHistory}
                    infoInfinitScroll={infoInfinitScroll}
                    setPerPage={setPerPage}
                    perPage={per_page}
                    isLoadHistory={isLoadHistory}
                    setSearchType={setSearchType}
                    setSearchText={setTextType}
                  />
                )}
              </Modal.Content>
            )}
          </form>
        )}

        {bDesviculateBiologial && (
          <ModalInformation
            isSubmit={false}
            titleIsCancel={intl.get("back_cap")}
            bgBtn="#1ECB4F"
            title={intl.get("ciq.unlinked_biological_variable_table")}
            description={intl.get("ciq.unlinked_biological_variable_table_description")}
            onCancel={() => {
              setBDesviculateBiologial(false)
              setIsCancelModal(false)
              setIsSubmitModal(false)
            }}
            onClose={() => {
              setBDesviculateBiologial(false)
              setIsCancelModal(false)
              setIsSubmitModal(false)
            }}
          />
        )}

        {isCancelModal && (
          <ModalInformation
            bgBtn="#1ECB4F"
            title={intl.get("ciq.edit_exam_analyte")}
            description={intl.get("ciq.changes_not_save")}
            onCancel={() => setIsCancelModal(false)}
            onClose={() => {
              fnCloseAllModals()
            }}
          />
        )}
      </Modal>
    </FormProvider>
  )
}
